export type InfoPageLang = 'cs' | 'sk' | 'en' | 'hu' | 'uk' | 'ru';

export interface InfoPageConfig {
  name: string;
  /**
   * i18n namespaces for the page body (`title1/title2/perex/content/list`) and
   * its meta tags. Optional: a Tembra-only page (`tembraPageUrl` set, no i18n
   * texts) omits them and renders purely from the CMS.
   */
  i18nNamespace?: string;
  metaNamespace?: string;
  paths: Partial<Record<InfoPageLang, string>>;
  perexAsHtml?: boolean;
  availableInUaRu?: boolean;
  hideHeaderOnMobile?: boolean;
  thematicCounsellingPath?: string;
  /**
   * Legal/document-style page (terms, cookies, processor list…). Widens the
   * content area so wide tables/documents use more of the white card.
   */
  legal?: boolean;
  /**
   * When set, the page title, content and meta tags are loaded from the Tembra
   * CMS page version whose `url` equals this value. With an i18n namespace it
   * overrides only `title`/`content`/meta (perex + FAQ stay from i18n); without
   * one the page is rendered entirely from the CMS (no perex, no FAQ).
   */
  tembraPageUrl?: string;
}

// New info pages: use a single English URL across all locales — do not translate
// the path per locale. The two entries below keep their localized paths only
// for backwards compatibility (existing SEO and external links).
export const infoPageRegistry: InfoPageConfig[] = [
  {
    name: 'listOfProcessors',
    paths: {
      cs: '/seznam-zpracovatelu',
      sk: '/zoznam-spracovatelov',
      hu: '/list-of-processors'
    },
    tembraPageUrl: 'seznam-zpracovatelu',
    legal: true
  },
  {
    name: 'protectionOfWhistleblowers',
    metaNamespace: 'protectionOfWhistleblowers',
    paths: {
      cs: '/ochrana-oznamovatelu',
      sk: '/ochrana-oznamovatelov',
      en: '/protection-of-whistleblowers',
      uk: '/zachist-vykryvaciv',
      ru: '/zashchita-razoblachiteley',
      hu: '/protection-of-whistleblowers'
    },
    availableInUaRu: true,
    legal: true,
    tembraPageUrl: 'ochrana-oznamovatelu'
  },
  {
    name: 'emergency',
    i18nNamespace: 'emergency',
    metaNamespace: 'emergency',
    paths: {
      cs: '/kdy-na-pohotovost',
      sk: '/kedy-na-pohotovost',
      en: '/emergency',
      hu: '/emergency',
      uk: '/emergency',
      ru: '/emergency'
    },
    perexAsHtml: true,
    availableInUaRu: true,
    hideHeaderOnMobile: true,
    thematicCounsellingPath: 'kdy-na-pohotovost'
  },
  {
    name: 'ePrescription',
    metaNamespace: 'ePrescription',
    paths: {
      cs: '/e-recept',
      sk: '/e-recept',
      en: '/e-prescription',
      hu: '/e-prescription'
    },
    tembraPageUrl: 'e-recept'
  }
];
